export default {
    'OPERACION_BANCO': (state, mutation) => {
        state.banco = mutation.banco
    }
}